import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnInit,
  Output,
  TemplateRef
} from "@angular/core";
import { compact } from "lodash-es";
import {
  ReportDesignerItemGroupVertical,
  ReportDesignerItemGroupVerticalConfig
} from "../../report-design-item";
import { ReportDesignerComponent } from "../report-designer.component";
import { EditableChangedEvent } from "src/app/components/ui/editable/editable.component";

@Component({
  selector: "snt-report-designer-group-vertical",
  templateUrl: "report-designer-group-vertical.component.html",
  styles: [
    `
      :host {
        display: flex;
        flex: 1;
      }
    `
  ],
  standalone: false
})
export class ReportDesignerGroupVerticalComponent implements OnInit {
  @Input()
  item!: ReportDesignerItemGroupVertical;

  @Input()
  templateOutlet!: TemplateRef<any>;

  @Input()
  level!: number;

  @Input()
  parentName!: string;

  @Input()
  readonly: boolean = false;

  @Output() config: EventEmitter<ReportDesignerItemGroupVerticalConfig> =
    new EventEmitter();

  formData = {
    title: "",
    cols: "1"
  };

  private _collapsed: boolean = false;

  get collapsed() {
    return this._collapsed;
  }

  set collapsed(value: boolean) {
    this._collapsed = value;
    this.item.childTitle = value ? this.formData.title : undefined;
  }

  private readonly reportDesigner = inject(ReportDesignerComponent);

  ngOnInit(): void {
    this.formData.title = this.item.config.title || "";
    this.formData.cols = this.item.config.cols || "1";
  }

  onTitleChanged(editableChangedEvent: EditableChangedEvent): void {
    this.formData.title = editableChangedEvent.value;

    this.item.config = {
      ...this.item.config,
      ...this.formData
    };

    this.config.emit(this.item.config);
  }

  onFieldDataChanged(): void {
    this.item.config = {
      ...this.item.config,
      ...this.formData
    };

    this.config.emit(this.item.config);
  }

  async renderPdfObject(): Promise<Record<string, any>> {
    const allRenderers = this.reportDesigner.renderers.toArray();
    const filteredRenderers = allRenderers.filter(
      (x) =>
        x.level === this.level + 1 && x.parentGroup === this.item.config.name
    );

    return {
      type: "group-vertical",
      config: {
        title: this.item.config.title,
        cols: this.item.config.cols,
        items: compact(
          await Promise.all(
            filteredRenderers.map((x) =>
              !!x.renderPdfObject ? x.renderPdfObject() : Promise.resolve(null)
            )
          )
        )
      }
    };
  }
}
